import { Canvas, useFrame } from "@react-three/fiber";
import { EffectComposer, Bloom } from "@react-three/postprocessing";
import { LaunchField } from "./LaunchField";
import { MenuDrones, type LaunchRequest } from "./MenuDrones";

/** Gentle parallax so the field reads as deep space even while holding still. */
function CameraDrift() {
  useFrame((state) => {
    const t = state.clock.elapsedTime;
    state.camera.position.x = Math.sin(t * 0.11) * 0.5;
    state.camera.position.y = 2 + Math.sin(t * 0.07) * 0.15;
    state.camera.lookAt(0, 3.1, -8);
  });
  return null;
}

export function HomeScene({
  settled,
  onSettled,
  launchingId,
  onLaunch,
}: {
  settled: boolean;
  onSettled: () => void;
  launchingId: string | null;
  onLaunch: (req: LaunchRequest) => void;
}) {
  return (
    <Canvas
      camera={{ position: [0, 2, 12], fov: 55, near: 0.1, far: 300 }}
      dpr={[1, 2]}
      gl={{ antialias: true }}
    >
      <color attach="background" args={["#03040a"]} />
      <CameraDrift />
      <LaunchField onSettled={onSettled} />
      <MenuDrones settled={settled} launchingId={launchingId} onLaunch={onLaunch} />
      <EffectComposer>
        {/*
          The studio's exact bloom: punchy but TIGHT. The first cut here was
          weak and smeary (intensity 0.85, threshold 0.08, default radius),
          which on a dense line of drones blooms every dim halo pixel and
          welds neighbours into a glowing rope with hot knots. Raising the
          threshold keeps the dim deck crisp and only lets hot cores glow.
        */}
        <Bloom
          intensity={1.15}
          luminanceThreshold={0.15}
          luminanceSmoothing={0.85}
          radius={0.72}
          mipmapBlur
        />
      </EffectComposer>
    </Canvas>
  );
}
